import * as React from 'react';
import { Container } from '@material-ui/core';
import { getLogoPath } from '../../logic/logo';
import { useConsentStyles } from './styles';

// Shell of the public consent page: header-green page with the logo above a
// white card (the alt logo has white dots and reads on this green), no Navbar,
// drawer or tabs. It is the page's only <main> landmark.
export default function ConsentLayout({ brandName, children }) {
  const classes = useConsentStyles();

  return (
    <Container component="main" maxWidth={false} disableGutters className={classes.page}>
      <img className={classes.logo} src={getLogoPath('alt')} alt={brandName} />
      {children}
    </Container>
  );
}
